angular.module('tf.services')

    .factory('HistoryService', ['HttpService','$q',
        function (HttpService, $q) {

            var service = {};

            var defaultLimit = 20;

            service.getFarmerHistory = function(fid, page, limit){
                var defer = $q.defer();
                limit = limit || defaultLimit;
                page = page || 0;
                HttpService.get('history', {fid : fid, page_size: limit, page: page}).then(function(res){
                    defer.resolve(res.data);
                }, defer.reject);
                return defer.promise;
            };
            service.getProjectHistory = function(pid, page, limit){
                var defer = $q.defer();
                limit = limit || defaultLimit;
                page = page || 0;
                HttpService.get('history', {pid : pid, page_size: limit, page: page}).then(function(res){
                    defer.resolve(res.data);
                }, defer.reject);
                return defer.promise;
            };
            service.getUserHistory = function(query, uid, page, limit){
                query.page_size = query.page_size || defaultLimit;
                query.page = query.page || '0';

                var defer = $q.defer();
                HttpService.get('history', angular.extend({}, uid? {uid : uid} : {}, _.omit(query, _.isUndefined))).then(function(res){
                    defer.resolve(res.data);
                }, defer.reject);
                return defer.promise;
            };

            return service;
        }])
;
